import React, { useState } from "react";

const SelectField = ({ options, name, onChange, placeholder }) => {
  const [selected, setSelected] = useState("placeholder");
  const OnChange = (e) => {
    setSelected(e.target.value);
    onChange(e);
  };

  return (
    <select
      className="bg-transparent border-b basis-[45%] md:basis-0 border-white text-white min-w-[150px] w-auto  outline-none pb-2"
      name={name}
      onChange={OnChange}
      value={selected}
    >
      <option value={name}>{placeholder ?? "select one option"}</option>
      {options?.map &&
        options?.map((option, index) => {
          const entries = Object.entries(option);
          return (
            <option key={"name-filter-option-" + index} value={entries[0][0]}>
              {entries[0][1]}
            </option>
          );
        })}
    </select>
  );
};

export default SelectField;
